module.exports = __webpack_public_path__ + "static/media/telinekataja.c1e6a43b.svg";